import sortStudents from './sortStudents.js';
import filterActiveStudents from './filterActiveStudents.js';
import onlyClasses from './onlyClasses.js';
import hashString from './hashString.js';
export default {
  sortStudents: sortStudents,
  filterActiveStudents: filterActiveStudents,
  onlyClasses: onlyClasses,
  hashString: hashString
};